export const regularExpresions = {
  Nombre: '(([a-zA-ZÀ-ÖØ-öø-ÿ]+[ ]{0,1}[a-zA-ZÀ-ÖØ-öø-ÿ]+))+',
  DiasMes: '([1-9]{1,1}|[1-2]{1,1}[0-9]{1,1}|[3]{1,1}[0-1]{1,1})$',
  CedulaPeru: '[A-Z0-9]+$',
  SoloUnDigito: '^[0-9]$',
  Digitos: '[100]|[0-9]{1,2}}',
  Montos: '^[0-9]+([.][0-9]+)?$',
  Identificacion: '^[0-9]{10,14}$',
  NumeroCuentas: '^[0-9]+$',
  Descripcion: '(([0-9a-zA-ZÀ-ÖØ-öø-ÿ]+)|([0-9a-zA-ZÀ-ÖØ-öø-ÿ]+[ ]{0,1}[0-9a-zA-ZÀ-ÖØ-öø-ÿ]+))+',
  Usuario: '([0-9]+[a-zA-Z]+)|([a-z]+[0-9a-zA-Z]+)',
  DiasDelMes: '([1-9]{1,1}|[1-2]{1,1}[0-9]|[3]{1,1}[0-1]{1,1}){1,1}',
  SoloDigitos: '^[0-9]+',
  AlfanumericoSinEspacioyespecial: '^[^ ]*$',
  PassRobustas: '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\.\+\\-;:,<>(){}\[\\]\"\'\|\/\=?]).{8,}$',
  UsuarioRobusto: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?!.*[!@#\$%\^&\*\.\+\\-;:,<>(){}\[\\]\"\'\|\/\ =?]).{5,}$'
};

export const EMPTY_STRING = ' ';

export const IDCNE = '9a1a03b8-dbfd-45cd-8af8-7527625f1d26'

export function nowDate() {
  return new Date().toISOString().split('T')[0];
}


export function EnmascararCuenta(numeroCuenta: string) {
  if (numeroCuenta.length < 7) {
      return numeroCuenta;
  } else if (numeroCuenta.length === 7) {
      return numeroCuenta.substring(0, 3) + "XXXX";
  } else {
      return numeroCuenta.substring(0, 3) + "XXXX" + numeroCuenta.substring(7);
  }
}
